var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var TodoListItem = /** @class */ (function (_super) {
    __extends(TodoListItem, _super);
    function TodoListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TodoListItem.prototype.render = function () {
        var _a = this.props, label = _a.label, completed = _a.completed, complete = _a.complete, id = _a.id;
        return (React.createElement("li", { className: "todo" },
            React.createElement("label", null,
                React.createElement("input", { type: "checkbox", checked: completed, onChange: function () { return complete(id); } }),
                " ",
                label)));
    };
    return TodoListItem;
}(React.Component));
export { TodoListItem };
